// Joya Headquarter — shared English strings. Same keys as common.he.js.
export default {
  // App shell and login (keys without the joya. prefix)
  'account.signOut': 'Sign out',
  'common.language': 'Language',
  'common.sessionExpiredSignIn': 'Your session has expired. Reload the page and sign in.',
  'menu.open': 'Menu',
  'menu.close': 'Close',
  'login.title': 'Joya Headquarter',
  'login.failed': 'Sign in failed',
  'login.network': 'Network error — is the server reachable?',
  'login.username': 'E-mail (as in the Allegro admin)',
  'login.password': 'Password',
  'login.signingIn': 'Signing in…',
  'login.signIn': 'Sign in',
  'joya.back': '← Back',
  'joya.loading': 'Loading…',
  'joya.unknown': 'not known',
  'joya.unknownTitle': 'This value is missing — it is not counted as zero',
  'joya.noAccess': 'This user has no access to Joya Headquarter. The chain admin can give access in Settings.',
  'joya.demoBanner': 'Demonstration data — these numbers are made up for the demo and are not real Joya data.',
  'joya.source': 'Source',
  'joya.period': 'Period',
  'joya.updated': 'Updated',
  'joya.location': 'Location',
  'joya.allLocations': 'All locations',
  'joya.company': 'Company',
  'joya.allCompanies': 'All companies',
  'joya.allCompanyLocations': 'All its locations',
  'joya.noCompany': 'No company',
  'joya.chooseLocation': 'Choose a location at the top of the page.',
  'joya.save': 'Save',
  'joya.cancel': 'Cancel',
  'joya.edit': 'Edit',
  'joya.delete': 'Delete',
  'joya.add': 'Add',
  'joya.approve': 'Approve',
  'joya.reject': 'Reject',
  'joya.close': 'Close',
  'joya.note': 'Note',
  'joya.noteOptional': 'Note (optional)',
  'joya.by': 'by',
  'joya.at': 'on',
  'joya.none': 'Nothing here yet.',
  'joya.demo': 'demo',
  'joya.estimate': 'estimate',
  'joya.known': 'known',
  'joya.missing': 'missing',
  'joya.from': 'From',
  'joya.to': 'To',
  'joya.details': 'Details',
  'joya.history': 'History',
  'joya.whoWhen': '{who} · {when}',

  'joya.role.CHAIN_ADMIN': 'Chain management',
  'joya.role.LOCATION_MANAGER': 'Restaurant manager',

  'joya.nav.label': 'Joya Headquarter navigation',
  'joya.nav.main': 'Main menu',
  'joya.nav.stock': 'Stock and purchasing',
  'joya.nav.manpower': 'Manpower',
  'joya.nav.performance': 'Performance',
  'joya.files.attach': "Attach a file",
  'joya.files.dropHere': "Drop the files here — they are checked before anything is saved",
  'joya.files.close': "Close",
  'joya.files.status.checking_one': "Checking the file…",
  'joya.files.status.checking_other': "Checking {count} files…",
  'joya.files.status.checked_one': "The file was checked. Look at the details and tap \"Import\".",
  'joya.files.status.checked_other': "{count} files were checked. Look at the details and tap \"Import\".",
  'joya.files.status.importing_one': "Importing…",
  'joya.files.status.importing_other': "Importing…",
  'joya.files.status.imported_one': "Import finished",
  'joya.files.status.imported_other': "Import finished",
  'joya.files.status.failed_one': "The file could not be checked",
  'joya.files.status.failed_other': "The files could not be checked",
  'joya.files.period': "Period",
  'joya.files.previous': "This file was already uploaded ({times} times). Another import does not double rows already saved.",
  'joya.files.useAdmin': "This file is imported on the admin Upload files page:",
  'joya.files.adminPage': "Upload files",
  'joya.files.chooseBranch': "Choose the branch",
  'joya.files.import_one': "Import",
  'joya.files.import_other': "Import {count} files",
  'joya.files.failed': "Failed",
  'joya.files.result.OK': "Saved",
  'joya.files.result.PARTIAL': "Partly saved",
  'joya.ask.downloadExcel': 'Download Excel',
  'joya.ask.suggestions': 'Suggested questions',
  'joya.area.askTitle': 'What would you like to know?',
  'joya.area.placeholder': 'Ask a question…',
  'joya.area.stock.title': 'Stock and purchasing',
  'joya.area.stock.intro': 'Ask about orders, shortages and what sold. Tap the field to see suggested questions.',
  'joya.area.stock.s1': 'What should we order for tomorrow?',
  'joya.area.stock.s2': 'Which shortages were reported this week?',
  'joya.area.stock.s3': 'What did the system learn from our orders?',
  'joya.area.stock.s4': 'Which dishes sold the most this week?',
  'joya.area.stock.s5': 'Which dishes sold less than last week?',
  'joya.area.stock.s6': 'Which items does the branch manager change most in the order list?',
  'joya.area.stock.s7': 'Which order lists are waiting for approval?',
  'joya.area.stock.s8': 'What data is missing to recommend an order?',
  'joya.area.stock.s9': 'Which items ran out most often in the last month?',
  'joya.area.stock.s10': 'How many of each dish sold last month?',
  'joya.area.people.title': 'Manpower',
  'joya.area.people.intro': 'Ask about shifts, employees, hours and payroll. Tap the field to see suggested questions.',
  'joya.area.people.s1': 'How many employees do we need in each shift next week?',
  'joya.area.people.s2': 'What is labor cost as a percent of revenue this month?',
  'joya.area.people.s3': 'Where did we work more hours than planned?',
  'joya.area.people.s4': 'Which shifts were the busiest last week?',
  'joya.area.people.s5': 'What payroll issues are there this month?',
  'joya.area.people.s6': 'Which staffing rules apply to this branch?',
  'joya.area.people.s7': 'How many hours were worked last week compared with the plan?',
  'joya.area.people.s8': 'Which days next week need the most employees?',
  'joya.area.people.s9': 'Which shift decisions are waiting for approval?',
  'joya.area.people.s10': 'What was the labor cost in each branch last month?',
  'joya.area.people.s11': 'How many cooks do we need on Friday morning?',
  'joya.area.people.s12': 'Which attendance data is missing?',
  'joya.area.performance.title': 'Performance',
  'joya.area.performance.intro': 'Ask about sales, diners and costs by branch and period. Tap the field to see suggested questions.',
  'joya.area.performance.s1': 'How were sales last week compared with the week before?',
  'joya.area.performance.s2': 'What is the revenue this month so far?',
  'joya.area.performance.s3': 'Which days had unusual sales?',
  'joya.area.performance.s4': 'Which branch sold the most this month?',
  'joya.area.performance.s5': 'What is the average per diner in each shift?',
  'joya.area.performance.s6': 'Which dishes bring the most revenue?',
  'joya.area.performance.s7': 'What is the labor cost percent in each branch?',
  'joya.area.performance.s8': 'Which days are missing in the sales data?',
  'joya.area.performance.s9': 'How many diners were there each day last week?',
  'joya.area.performance.s10': 'What should be checked in the branches today?',
  'joya.nav.bank': 'Bank',
  'joya.area.bank.title': 'Bank',
  'joya.area.bank.intro': "Ask about the company's bank account: balance, money in and out, deposits and payments. The data is from the last uploaded bank file. Tap the field to see suggested questions.",
  'joya.area.bank.s1': 'What is the bank balance today?',
  'joya.area.bank.s2': 'How much money came in and went out this month?',
  'joya.area.bank.s3': 'How much did Wolt transfer this month?',
  'joya.area.bank.s4': 'How much came in from the credit card companies last week?',
  'joya.area.bank.s5': 'What were the biggest payments this month?',
  'joya.area.bank.s6': 'Which checks were paid this week?',
  'joya.area.bank.s7': 'When was the balance lowest this month?',
  'joya.area.bank.s8': 'How much did we pay for VAT and National Insurance this year?',
  'joya.role.ACCOUNTANT': "Accounting",
  'joya.nav.accounting': "Accounting",
  'joya.area.accounting.title': "Accounting",
  'joya.area.accounting.intro': "Ask about matching the register with the bank: did the money from credit cards, Wolt and other payments arrive in the account, and what were the fees. Tap the field to see suggested questions.",
  'joya.area.accounting.s1': "Compare card sales at the register with the money in the bank, by week, this month",
  'joya.area.accounting.s2': "Did all the card money of last week arrive in the bank?",
  'joya.area.accounting.s3': "How much fee did Max take last month?",
  'joya.area.accounting.s4': "Did the American Express payments of last month arrive?",
  'joya.area.accounting.s5': "Compare Wolt sales at the register with Wolt's transfers in the bank this month",
  'joya.area.accounting.s6': "How much card money is expected to come in this week?",
  'joya.area.accounting.s7': "Which weeks have an unusual difference between the register and the bank?",
  'joya.area.accounting.s8': "How much cash was recorded at the register this month?",
  'joya.area.performance.s11': 'What credit card income do we expect this week?',
  'joya.nav.areas': 'Work areas',
  'joya.nav.overview': 'Chain overview',
  'joya.nav.workspace': 'Restaurant workspace',
  'joya.nav.orders': 'Ordering & replenishment',
  'joya.nav.staffing': 'Shift planning',
  'joya.nav.ordering': 'Ordering',
  'joya.nav.shortages': 'Report a shortage',
  'joya.nav.learned': 'What the system learned',
  'joya.nav.people': 'Staff & payroll',
  'joya.nav.rules': 'Staffing rules & shifts',
  'joya.nav.labor': 'Labor cost',
  'joya.nav.payroll': 'Payroll preparation checks',
  'joya.nav.employees': 'Employees & id mapping',
  'joya.nav.hq': 'Headquarters',
  'joya.nav.sales': 'Sales & performance',
  'joya.nav.tasks': 'Tasks',
  'joya.nav.ask': 'Ask headquarters',
  'joya.nav.data': 'Data',
  'joya.nav.import': 'Import & manual entry',
  'joya.nav.menu': 'Menu & ingredients',
  'joya.nav.settings': 'Settings',

  'joya.status.DRAFT': 'Draft',
  'joya.status.APPROVED': 'Approved',
  'joya.status.ORDERED': 'Ordered',
  'joya.status.REJECTED': 'Rejected',
  'joya.status.OPEN': 'Open',
  'joya.status.IN_PROGRESS': 'In progress',
  'joya.status.DONE': 'Done',
  'joya.status.CANCELLED': 'Cancelled',
  'joya.status.CORRECTED': 'Corrected',
  'joya.status.ACCEPTED': 'Accepted as correct',
  'joya.status.DISMISSED': 'Not a problem',
  'joya.status.NEW': 'New',
  'joya.status.DRAFT_READY': 'Reply draft ready',
  'joya.status.RESPONDED': 'Responded',
  'joya.status.CLOSED': 'Closed',

  'joya.wd.0': 'Sunday',
  'joya.wd.1': 'Monday',
  'joya.wd.2': 'Tuesday',
  'joya.wd.3': 'Wednesday',
  'joya.wd.4': 'Thursday',
  'joya.wd.5': 'Friday',
  'joya.wd.6': 'Saturday',

  'joya.unit.DINERS_PER_SHIFT': 'diners per shift',
  'joya.unit.DINERS_PEAK_HOUR': 'diners in the peak hour',
  'joya.unit.CONCURRENT_DINERS_PEAK': 'diners seated at once (peak)',
  'joya.unit.ORDERS_PER_SHIFT': 'orders (checks) per shift',
  'joya.unit.ORDERS_PEAK_HOUR': 'orders (checks) in the peak hour',
  'joya.unitHelp.DINERS_PER_SHIFT': 'Sum of diners on checks opened during the shift.',
  'joya.unitHelp.DINERS_PEAK_HOUR': 'The busiest clock hour of the shift: diners on checks opened in that hour.',
  'joya.unitHelp.CONCURRENT_DINERS_PEAK': 'The most diners seated at the same moment (checked every 15 minutes). Needs the check close time.',
  'joya.unitHelp.ORDERS_PER_SHIFT': '"Order" = one POS check (Beecomm) opened during the shift.',
  'joya.unitHelp.ORDERS_PEAK_HOUR': 'The busiest clock hour: checks opened in that hour.',

  'joya.conf.HIGH': 'high confidence',
  'joya.conf.MEDIUM': 'medium confidence',
  'joya.conf.LOW': 'low confidence',
  'joya.conf.NONE': 'no basis for a quantity',


  'joya.ask.title': 'Ask or request a change',
  'joya.ask.placeholder': 'e.g. Why do we need three cooks on Thursday morning?',
  'joya.ask.send': 'Send',
  'joya.ask.delete': 'Delete this question',
  'joya.ask.thinking': 'Headquarters is calculating… (usually under a minute)',
  'joya.ask.failed': 'No answer came back.',
  'joya.ask.unverified': 'Numbers in the answer that are not in the calculations — check them:',
  'joya.ask.howCalculated_one': 'How this was calculated (1 calculation)',
  'joya.ask.howCalculated_other': 'How this was calculated ({count} calculations)',
  'joya.ask.rawNumbers': 'Full data',
  'joya.ask.proposal': 'Proposed change — not saved yet',
  'joya.ask.apply': 'Apply and save',
  'joya.ask.discard': 'No, thanks',
  'joya.ask.ps.APPLIED': 'saved',
  'joya.ask.ps.DISCARDED': 'discarded',
  'joya.ask.ps.PENDING': 'waiting',
  'joya.ask.whatIfNote': 'A "what if" calculation — the stored rules were not changed.',
  'joya.ask.howItWorks': 'Numbers are calculated by the system from your data (not by the language model), and each calculation shows its period and source. A change is saved only after you confirm it.',
  'joya.ask.op.add': 'Add:',
  'joya.ask.op.set_qty': 'Change quantity:',
  'joya.ask.op.set': 'Change:',
  'joya.ask.op.remove': 'Remove:',
  'joya.ask.op.restore': 'Restore:',
  'joya.ask.op.note': 'Note:',
  'joya.ask.rule.add': 'New team rule —',
  'joya.ask.rule.edit': 'Change a team rule —',
  'joya.ask.rule.remove': 'Remove a team rule —',
  'joya.ask.rule.before': 'Before:',
  'joya.ask.rule.area.ALL': 'all areas',
  'joya.ask.rule.area.STOCK': 'Stock and purchasing',
  'joya.ask.rule.area.MANPOWER': 'Staff & payroll',
  'joya.ask.rule.area.PERFORMANCE': 'Performance',
  'joya.ask.rule.area.BANK': 'Bank',
  'joya.ask.rule.area.ACCOUNTING': 'Accounting',
};
